import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetFilterProductsSlice = createSlice({
    name: "getFilterProducts",
    initialState,
    reducers: {
        getFilterProductsRequest(state) {
            state.loading = true;
        },
        getFilterProductsRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getFilterProductsRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getFilterProductsRequest,
    getFilterProductsRequestSuccess,
    getFilterProductsRequestError,
} = GetFilterProductsSlice.actions;

export default GetFilterProductsSlice.reducer;
